<template>
  <div class="course-box">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
<!--      <el-breadcrumb-item :to="{ path: '/onlineTraining/trainingPlan' }">培训任务</el-breadcrumb-item>-->
<!--      <el-breadcrumb-item :to="{ path: '/onlineTraining/course' }">培训课程</el-breadcrumb-item>-->
      <el-breadcrumb-item>培训任务</el-breadcrumb-item>
      <el-breadcrumb-item>培训课程</el-breadcrumb-item>
      <el-breadcrumb-item>学习记录</el-breadcrumb-item>
    </el-breadcrumb>
    <PublicSearch class="user-search" :searchData="searchData" @onSearch="() => { pageInfo.currentPage = 1; getData() }">
      <template #clazzName>{{ $store.state.institution }}</template>
      <template #right>
        <el-button
          v-buttonAuth="'system:TrainersLearningRecords:export'"
          size="small"
          type="primary"
          class="mg-btm20"
          @click="handleAction(1)">导出</el-button>
        <el-button
          size="small"
          class="mg-btm20"
          @click="$router.back()">返回</el-button>
      </template>
    </PublicSearch>
    <my-table
        height="80%"
        :columns="customColumns"
        :tableData="tableData"
        :loading="isLoading"
        @selection-change="handleSelectionChange"
        @row-click="handleRowClick">
      <template #deptName="item">{{ item.row.createdBy ? item.row.createdBy.deptName : '无' }}</template>
      <template #courseCode="item">{{ item.row.course ? item.row.course.courseCode : '无' }}</template>
      <template #courseCategoryName="item">{{ item.row.course ? item.row.course.courseCategoryName : '无' }}</template>
      <template #courseName="item">{{ item.row.course ? item.row.course.courseName : '无' }}</template>
      <template #workNo="item">{{ item.row.createdBy ? item.row.createdBy.workNo : '无' }}</template>
      <template #userName="item">{{ item.row.createdBy ? item.row.createdBy.userName : '无' }}</template>
    </my-table>
    <div class="main-pagination">
      <Pagination :child-msg="pageInfo" @callFather="callFather"></Pagination>
    </div>
  </div>
</template>

<script>
import PublicSearch from '@/components/publicSearch.vue';
import MyUpload from '@/components/myUpload.vue';
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
import myForm from '@/components/myForm.vue';
import api from '../../../api/onlineTraining/studyRec';
import { fileDownload, downloadFile } from "../../../utils/util";
import { deptTree } from "../../../api/dept";
export default {
  components: {
    PublicSearch,
    MyUpload,
    MyTable,
    Pagination,
    myForm
  },
  data () {
    return {
      searchData: {
        inputList: [
          { label: '所属机构：', prop: 'clazzName' },
          {
            label: '所属部门',
            prop: 'deptId',
            props: 'dept',
            type: 'caScaDer',
            ref: 'casCaDerOne',
            options: [],
            casCaDerProps: { label: 'deptName', value: 'deptId', checkStrictly: true, Show: false, emitPath: false }
          },
          { label: '课程名称：', prop: 'courseName', type: 'input', placeholder: '请输入课程名称' }
          // { label: '姓名：', prop: 'userName', type: 'input', placeholder: '请输入姓名' }
        ],
        searchQuery: {  } //  搜索参数
      }, //  搜索参数
      customColumns: [
        { label: '所属机构', prop: '', formatter: () => { return this.$store.state.institution } },
        { label: '所属部门', slot: 'deptName' },
        { label: '课程编码', slot: 'courseCode' },
        { label: '分类', slot: 'courseCategoryName' },
        { label: '课程名称', slot: 'courseName' },
        { label: '员工号', slot: 'workNo' },
        { label: '姓名', slot: 'userName' },
        { label: '学习开始时间', prop: 'startStudyTime' },
        { label: '学习时长', prop: 'studyTimesText' }
      ],
      isLoading: false,
      tableData: [],
      pageInfo: { currentPage: 1, pageSize: 10, total: 0 }, //  分页参数
      URL: envConfig.NODE_IMG_API
    }
  },
  created () {
    this.getDictionary();
    this.getData();
  },
  methods: {
    fileDownload,
    async getDictionary () {
      const res = await deptTree();
      this.searchData.inputList[1].options = res.data;
    },
    //  改变分页及大小
    callFather (data) {
      this.pageInfo.currentPage = data.currentPage;
      this.pageInfo.pageSize = data.pageSize;
      this.getData();
    },
    //  获取数据
    async getData () {
      const params = {
        pageNum: this.pageInfo.currentPage,
        pageSize: this.pageInfo.pageSize,
        ...this.$route.query
      };
      const res = await api.studyRecPage(Object.assign(this.searchData.searchQuery, params));
      console.log(res);
      this.tableData = res.data.records;
      this.pageInfo.total = res.data.total;
    },
    async handleAction (index, data) {
      const type = 'vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      switch (index) {
        case 1: //  导出
          downloadFile(await api.studyRecExport({
            pageNum: this.pageInfo.currentPage,
            pageSize: this.pageInfo.pageSize,
            ...this.searchData.searchQuery
          }), type, `${this.$route.query.userName}-学习记录`);
          break;
      }
    },
    handleSelectionChange (selection) {
      console.log('选择发生变化：', selection);
    },
    handleRowClick (row) {
      console.log('点击行：', row);
    }
  }
}
</script>

<style lang="scss" scoped>
.course-box {
  height: 100%;
  .user-search {
    margin-top: 20px;
  }
  .operate {
    margin-left: 10px;
    &:first-child {
      margin-left: 0;
    }
  }
  .view-list {
    width: 70%;
    margin: 0 auto;
    font-size: 16px;
    .view-item {
      display: flex;
      align-items: flex-start;
      padding: 5px 0;
      .view-label {
        width: 100px;
        text-align: right;
      }
    }
  }
}
</style>
<style lang="scss">
.el-loading-mask {
  z-index: 5000 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/onlineTraining/trainingPlan/TrainersLearningRecords.vue